import { render, staticRenderFns } from "./InformationLayout.vue?vue&type=template&id=22ae5c59&scoped=true&"
import script from "./InformationLayout.vue?vue&type=script&lang=ts&"
export * from "./InformationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./InformationLayout.vue?vue&type=style&index=0&id=22ae5c59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae5c59",
  null
  
)

export default component.exports